/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
];
export const compactNavigation: FuseNavigationItem[] = [
    
    {
        id   : 'example',
        title: 'Inicio',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/example'
    },
    {
        id   : 'solicitudes',
        title: 'Solicitudes',
        type : 'basic',
        icon : 'heroicons_outline:document', 
        link : '/tablasolicitud' 
    },
    {
        id   : 'rub',
        title: 'RUB',
        type : 'aside',
        icon : 'heroicons_outline:identification', 
        children: [], 
    },
    {
        id   : 'catalogos',
        title: 'Catálogos',
        type : 'aside',
        icon : 'heroicons_outline:document-duplicate', 
        children: [], 
    },
    {
        id   : 'tablacitas',
        title: 'Citas',
        type : 'basic',
        icon : 'heroicons_outline:calendar-days', 
        link : '/tablacitas' 
    }
    
];
export const futuristicNavigation: FuseNavigationItem[] = [
    
];
export const horizontalNavigation: FuseNavigationItem[] = [
    
];


/*export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Inicio',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/example'
    },
    {
        id   : 'new-link',
        title: 'Solicitudes',
        type : 'basic',
        icon : 'heroicons_outline:document', 
        link : '/tablasolicitud' 
    },
    {
        id   : 'rub',
        title: 'RUB',
        type : 'basic',
        icon : 'heroicons_outline:identification', 
        link : '/rub' 
    },
    {
        id   : 'catalogos',
        title: 'Catálogos',
        type : 'basic',
        icon : 'heroicons_outline:document-duplicate', 
        link : '/catalogo' 
    },
    {
        id   : 'tablacitas',
        title: 'Citas',
        type : 'basic',
        icon : 'heroicons_outline:calendar-days', 
        link : '/tablacitas' 
    }
    

    
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];*/
